import { render, staticRenderFns } from "./GroupRow.vue?vue&type=template&id=11cb31c8"
import script from "./GroupRow.vue?vue&type=script&lang=ts"
export * from "./GroupRow.vue?vue&type=script&lang=ts"
import style0 from "./GroupRow.vue?vue&type=style&index=0&id=11cb31c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports